var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeAnywere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.861,
    height: 56.861,
    viewBox: "0 0 56.861 56.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17957",
    "data-name": "Group 17957",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_34_Global_Globe_Investment_Money",
    "data-name": "34 Global, Globe, Investment, Money",
    d: "M29.931,2A27.931,27.931,0,1,0,57.861,29.931,27.931,27.931,0,0,0,29.931,2ZM54.548,23.811a19.4,19.4,0,0,0-4.3-2.679,13.216,13.216,0,0,1-.3,2.679c3.453,1.777,5.383,3.948,5.383,6.119,0,3.441-5.078,7.072-13.318,8.887a57.5,57.5,0,0,0,.622-6.119,11.807,11.807,0,0,1-2.539.8,56.977,56.977,0,0,1-.635,5.853,58.019,58.019,0,0,1-9.522.736,58.019,58.019,0,0,1-9.42-.736,58.019,58.019,0,0,1-.736-9.42,57.817,57.817,0,0,1,.736-9.395c1.409-.241,2.882-.419,4.393-.559a11.566,11.566,0,0,1,.482-2.539c-1.511.1-2.971.267-4.367.47,1.841-8.29,5.472-13.369,8.912-13.369,1.828,0,3.707,1.435,5.345,4.012a13.381,13.381,0,0,1,2.273-.2h.559A17.254,17.254,0,0,0,36.037,5.3a25.392,25.392,0,0,1,18.51,18.51ZM29.931,55.322c-3.441,0-7.072-5.078-8.887-13.331a61.853,61.853,0,0,0,8.887.635,61.8,61.8,0,0,0,8.887-.635C36.977,50.244,33.346,55.322,29.931,55.322ZM17.87,38.818C9.617,37,4.539,33.371,4.539,29.931c0-3.694,5.459-7.11,13.331-8.887a59.569,59.569,0,0,0-.635,8.887,61.853,61.853,0,0,0,.635,8.887ZM23.862,5.3c-2.438,2.869-4.38,7.427-5.51,13.026C12.715,19.444,8.2,21.374,5.314,23.8A25.468,25.468,0,0,1,23.862,5.3ZM5.3,36c2.869,2.45,7.427,4.393,13.039,5.523,1.13,5.612,3.072,10.157,5.523,13.039A25.468,25.468,0,0,1,5.3,36ZM36.075,54.535c2.438-2.857,4.355-7.4,5.472-13.026,5.6-1.13,10.157-3.06,13.013-5.5A25.392,25.392,0,0,1,36.075,54.535Z",
    transform: "translate(-2 -2)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    transform: "translate(23.588 7)",
    fill: "#284261",
    stroke: "#d7df23",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17955",
    "data-name": "Group 17955",
    transform: "translate(30.951 12.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11897",
    "data-name": "Path 11897",
    d: "M46.536,38.845a2.807,2.807,0,0,0-.635-.872,4.1,4.1,0,0,0-.66-.487,3.376,3.376,0,0,0,.591-.2,2.018,2.018,0,0,0,.741-.538,1.968,1.968,0,0,0,.408-.847,1.591,1.591,0,0,0-.109-1.064,2.014,2.014,0,0,0-.623-.782,3.492,3.492,0,0,0-.889-.521c-.182-.08-.387-.13-.58-.2l.358-1.685-.847-.18-.117-.025-.358,1.682-.991-.217.356-1.676-.976-.208-.357,1.678-2.062-.436-.214,1.017.3.089c.083.028.208.076.361.134a2.132,2.132,0,0,1,.357.2c.086.054.118.089.107.1a.313.313,0,0,1,0,.184l-1.192,5.6a.713.713,0,0,1-.058.153c-.011.015-.048.033-.138.046a1.434,1.434,0,0,1-.371-.014,2.96,2.96,0,0,1-.455-.055l-.308-.036-.214,1.017,2.117.455-.356,1.675.976.208.356-1.676.991.217-.355,1.67.976.208.354-1.685a5.083,5.083,0,0,0,.9.058,3.98,3.98,0,0,0,1.172-.19,2.5,2.5,0,0,0,1-.574,1.973,1.973,0,0,0,.59-1.057A2.44,2.44,0,0,0,46.536,38.845Zm-2.773-4.59a1.235,1.235,0,0,1,.925,1.438,1.2,1.2,0,0,1-1.425.923L42.1,36.37l.5-2.36Zm-1.092,6.327-1.424-.3.6-2.808,1.424.3a1.435,1.435,0,0,1-.6,2.808Z",
    transform: "translate(-37.963 -31.028)",
    fill: "#d7df23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeAnywere);
export default __webpack_public_path__ + "static/media/tradeAnywere.399274da38a35fad65481b9d987d151b.svg";
export { ForwardRef as ReactComponent };